<template>
	<transition name="modal" class="sm">
		<section class="global-modal" @click="close">
			<section class="modal-dialog" role="document" @click.stop>
				<section class="modal-wrapper">
					<header class="modal-header">
						<span class="modal-title" role="heading">{{ modalTitle }}</span>
						<button
							type="button"
							class="b360-modal-close-btn"
							aria-label="Close Modal"
							@click="close"
						>
							<font-awesome-icon :icon="['far', 'times-circle']" />
						</button>
					</header>
					<section class="modal-content">
						<slot name="modalContent" />
					</section>
					<footer class="modal-footer">
						<button class="b360-modal-delete-btn" v-if="deleteBtn">
							Delete
						</button>
						<div class="user-action-btns">
							<button
								type="button"
								class="b360-btn b360-modal-cancel-btn"
								@click="$emit('close')"
								aria-label="Cancel to Close Modal"
							>
								Cancel
							</button>

							<!-- TODO: To drive the success button content we will need to add class of .success to the b360-modal-action-btn -->
							<button
								type="button"
								class="b360-modal-action-btn"
								:aria-label="`click ${actionBtnName}`"
								@click="actionCall"
							>
								<!-- TODO: Need to hide parts of action button depending on the response to API such as hide .btn-text if waiting or success, and show either waiting or success icons -->
								<span class="btn-text">{{ actionBtnName }}</span>
								<font-awesome-icon
									class="waiting-animation"
									:icon="['far', 'circle-notch']"
									v-show="waiting"
								/>
								<font-awesome-icon
									class="success-animation"
									:icon="['far', 'check']"
									v-show="success"
								/>
							</button>
						</div>
					</footer>
				</section>
			</section>
		</section>
	</transition>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'PartnerModal',
	props: {
		show: Boolean,
		modalTitle: String,
		actionBtnName: String,
		deleteBtn: Boolean,
	},
	methods: {
		...mapActions(['createPartner', 'deletePartner', 'editPartner']),
		close() {
			this.$emit('close');
		},
		actionCall() {
			this.close();
			this.$emit('modal-action', this.actionBtnName);
		},
	},
	mounted() {
		document.addEventListener('keydown', function closeModal(e) {
			if (this.show && e.code === 'Escape') this.close();
		});
	},
};
</script>

<style lang="scss" scoped>
.global-modal {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba($black, 0.5);
	display: block;
	transition: opacity 0.15s linear;
	overflow-y: auto;
}
.modal-dialog {
	max-width: 1280px;
	width: 80vw;
	display: block;
	top: 50px;
	position: relative;
	margin: 0 auto;

	@include mobile {
		width: calc(100vw - 30px);
	}

	.modal-wrapper {
		background-color: $off-white;
		border-radius: 5px;
		box-shadow: 0 0 20px 0 rgba($black, 0.15);
		position: relative;
	}

	header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 30px;
		background-color: $white;
		border-radius: 5px 5px 0 0;
		box-shadow: inset 0 -1px 0 0 $border-color-light;
		padding: 15px;
		color: $text-base-color;
		@include typo--roboto__medium;
		font-size: $b360-font-size--large;

		.b360-modal-close-btn {
			background-color: transparent;
			border: 0;
			height: 24px;
			color: $brand-blue;
			cursor: pointer;
			font-size: $b360-font-size--larger;
		}
	}

	.modal-content {
		padding: 20px;

		.b360-grid-row {
			margin-bottom: unset;
		}
	}

	footer {
		background-color: $white;
		min-height: 45px;
		border-radius: 0 0 5px 5px;
		box-shadow: inset 0px 1px 0px 0px $border-color-light;
		padding: 15px;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;

		.user-action-btns {
			display: flex;
			flex-wrap: wrap;
			margin-left: auto;

			@include mobile {
				width: 100%;
			}
		}
	}
}

.suggested-posts-container .modal-dialog .modal-content {
	padding: {
		left: 0;
		right: 0;
	}

	margin-bottom: 0;
}

.sm {
	.modal-dialog {
		max-width: 480px;
	}
}

.md {
	.modal-dialog {
		max-width: 600px;
	}
}

.lg {
	.modal-dialog {
		max-width: 920px;
	}
}

.b360-grid-row {
	margin-bottom: unset;
}

.modal-enter,
.modal-leave-to {
	opacity: 0;
	transition: opacity 0.5s ease-out;
}

// TODO: Figure out why the Vue Transition -enter doesn't work for targeted nested item like it works for -leave-to nested items
.modal-enter .modal-dialog {
	transform: translate(0, 50px);
	transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.modal-leave-to .modal-dialog {
	transform: translate(0, -50px);
	opacity: 0;
	transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}
</style>
